<fieldset>
    <legend>Theme</legend>

      <!-- Theme Selector -->
      <div class="theme-selector">
        <p-dropdown [options]="themes" [ngModel]="selectedTheme" placeholder="Select a Theme" (onChange)="setTheme($event.value)"> <!-- -->
        </p-dropdown>
        @if (showUpdate){
            <span class="update-text">Your theme has been saved</span>
        }
      </div>
  </fieldset>